// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"28f0d1bb","453":"30c572e1"}[chunkId] + ".chunk.js";
};